import { Component, Input } from '@angular/core';
import { StatusPill } from '../../../../models/shared/status-pill';
import { ProfileBadgeConfiguration } from '../../../../models/users/dto/profile-badge-configuration';

@Component({
  selector: 'app-labeled-list-item',
  templateUrl: './labeled-list-item.component.html',
  styleUrls: ['./labeled-list-item.component.scss']
})
export class LabeledListItemComponent {
  @Input() label: string | undefined;
  @Input() text: string | number | undefined;
  @Input() url: string | undefined;
  // Status Pill
  @Input() statusPills: StatusPill[] | undefined;
  // User Profile Badge
  @Input() initials: string | undefined;
  @Input() profileBadgeConfiguration: ProfileBadgeConfiguration | undefined;

  public trackByPillName(_: number, pill: StatusPill): string {
    return pill.name;
  }
}
